import i18n from 'i18next';
import { addYears, differenceInMinutes } from 'date-fns';

import { defaultLocale, defaultLocaleString, locales } from '#core/const/locales';

export const getLocaleStringForDateFns = (lang = i18n.language) => {
    return lang || defaultLocaleString;
};

export const getLocaleForDateFns = (lang = i18n.language) => {
    return locales[lang] || defaultLocale;
};

export const getStorageTimeInMinutes = (date = new Date()) => {
    const nextYear = addYears(date, 1);

    return differenceInMinutes(nextYear, date);
};
